"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgForward(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.393 5L12 6.476 16.27 11H4v2h12.27L12 17.524 13.393 19 20 12z" })));
}
exports.default = tombacIcon_1.default('Forward')(SvgForward);
//# sourceMappingURL=Forward.js.map